/**
 * @title addtocart.js: Sub-module
 * @description Associated with ProductForm.jsp
 * This JS file binds add to cart event listeners.
 * Checks if a selection is back ordered to invoke a
 * backordered modal.
 */
define(['product_helper','mathtable'], function(phelper, mathtable) {
    var AddToCart = {
        init : function() {
            this.validate();            
            if ($('#ProductForm').length && $("span#backordered").length) { 
                phelper.bindSubmitToBackOrderModal() // Here because span#backordered was included on the page
            } else { // Nothing backordered, add-to-cart button submit normally.
                $("#ProductForm input[name='add-to-cart']").unbind('click').click(function (event) {
                	if(event != undefined && event.target != undefined){
                		let callerElement = event.target;
                    COSTCO.dialog.returnFocusOnCallerElement(callerElement);
                	}else {
                		COSTCO.dialog.returnFocusOnCallerElement(document.activeElement);
                	}
                  $('#ProductForm').submit();
                });
            }
        },

        validate : function(){
        	
        	$.validator.addMethod(
        			"quantityincrement",
        			function(value,element){
        				var $quantityIncrement = $(element).data("quantity-increment");
        				var errorMesg = $(element).data("error-message");
        				
        				var quantityIncrement = 1; //default quantityIncrement is always 1 (a whole number)
        				if(typeof $quantityIncrement == undefined || !$quantityIncrement) {
        					return true;
        				}
        				var qty = parseInt($quantityIncrement);
        				if(qty) {
        					quantityIncrement = qty;
        				}
        				if(value%quantityIncrement != 0) {
        					return false;
        				}
        				return true;
        			},
        			function(params, element) {
        				
            			return $(element).data("error-message")+" "+$(element).data("quantity-increment");

        			}
        	);
        	
        	var _rules = {
        			 submitHandler: function(form) {
		                var item_type = phelper.item_type,
		                    $product_error = $('body').find('.product-error'),
		                    $add_success = $(form).find('.add-success'),
		                    quantity_obj = phelper.is_valid_quantity(item_type, $('input[name=quantity]')),
		                    valid = true;
		                // Clear any previous error/success state and disable add to cart
		                $product_error.html('');
		                tobaccoProduct =  $('#tobaccoProduct').val()=="true"?true:false;
		                if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE && tobaccoProduct) {
		                	$('#add-to-cart').addClass('interaction-element');
		                	$('#error-notification-placeholder').empty();
		                	$('#error-notification-placeholder').addClass('hide');
	                    }
		                $add_success.html('');
		                // Disable quantity and add to cart to avoid spam
		                $('#add-to-cart input').attr('disabled', 'disabled');
		                $('input[name=quantity]').attr('disabled', 'disabled');
		                
		                // Check if we have a valid quantity
		                if (!quantity_obj.valid) {
		                	$product_error.html(quantity_obj.message);
		                	if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
		                		$('#minQtyText ').addClass('error');
			                }
		                	valid = false;
		                }
		                // Check if we have a valid sku resolved
		                if (valid && !phelper.is_sku_resolved(item_type, quantity_obj)) {
		                    $product_error.html("<span class='sr-only'>" + messages.ERROR + "</span>" + messages.ERR_ADD_TO_CART_SELECT_ONE);
		                    valid = false;
		                }
		                // If valid, Add to cart
		                if (valid && (typeof $('#vendorName').val() !== 'undefined' && ($('#vendorName').val().toLowerCase().includes('narvar') || COSTCO.Product.eddFormDisplayed != true  || ($('#ProductForm').length && $("span#backordered").length) )) ) {
		                    this.ajaxAddToCart('#ProductForm',
		                        this.product_form_done, 
		                        this.product_form_fail,
		                        this.product_form_always);
		                    $('#add-to-cart-btn').not('[offscreen]').focus(); 
		                } else { // enable quantity and add to cart
		                	if(COSTCO.Product.eddFormDisplayed === '' || $('#edd-date-msg.hide').length == 0){
		                		$('#add-to-cart input').removeAttr('disabled');
		                	}
		                    $('input[name=quantity]').removeAttr('disabled');
		                    $('#minQtyText').focus();
		                }
		            }.bind(this)
        	};
        	var appType = $('#applicationType').val();
        	if(appType=='BD'){
        		_rules.rules = { 
					quantity : {quantityincrement:true}
				};
        		
        		_rules.messages = {
 				   quantity: {
 					  quantityincrement : function(params, element) {
 						  let unitOfMeasure = COSTCO.Product.getUnitOfMeasure($(element));
 					 	  let increment = COSTCO.Product.getQuantityStep($(element), unitOfMeasure);
 					 	  return "<p class='sr-only'>" + messages.ERROR + "</p>" + $(element).data("error-message") + " " + increment;
 					}
 				   }
 				};
        		
 				_rules.errorPlacement = function(error, element) {
 	        		 $product_error = element.closest('#ProductForm').find('.product-error');
 	        		 $product_error.html(error.css({"margin" : 0}));
 	        	    COSTCO.Product.expendErrorOnQtyUnit(element, 'span');
 	            };
        	}
        	
        	if($('#ProductForm') ){
        		var validate = $('#ProductForm').validate(_rules);
        		if(validate!= undefined ){
        			validate.form();
        		}
        	}
            
        },

        add_related: function(form, done, fail, always) {
            $(form).find('.related-success').empty();
            $(form).find('.product-error').empty();
            $(form).find('button.add-to-cart').attr('disabled', 'disabled');
            this.ajaxAddToCart(form, done, fail, always);
        },

        ajaxAddToCart: function(form, done, fail, always) {
        	 let isRestrictedPostalCode = COSTCO.Header.checkIsRestricted();
			 const singleVariant = "single_variant";
			 const multiVariant = "multi-variant";
        	 var targetedAttribute = $('#targetedCartBehaviour').val();
        	 var targetedCart = "";
             if(targetedAttribute !== undefined && targetedAttribute === 'Membership'){
                //Any new behaviour, like Tickets, can be added to this condition to ensure that item is added to targeted cart
            	 targetedCart = targetedAttribute;
             }
        	//Fetch the contract specific flag for the Depot catalog flow
        	var programType = $('#programType').val();
        	var contractIdentifier ="";
        	if(typeof programType === "undefined" ){
        		programType = "";
        	}
        	if(programType == "2DayDelivery"){
        		contractIdentifier = "Regional";
        	}

        	 let isRelatedForm = (form.indexOf('#RelatedProductForm') >= 0) ? true : false;
            var $form = $(form),
                locale = COSTCO.util.getLocale(),
                productErrorDiv = $form.find('.product-error').empty(),
                relatedProductErrorDiv = $form.find('.related-product-error').empty(),
                quantity_text = messages.RWD_QUANTITY + ' ',
                quantity,
                final_price = (locale=='en-US'||locale=='en-CA'?' $':'')
                    + (isRelatedForm ? $form.find('.price').text().replace('$','') : (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE ? $('#pull-right-price .value').text() : $('.your-price .value').text()) ) + (locale=='fr-CA'?' $':''),
                formData = $form.serializeArray(),
                cleanData = {'ajaxFlag': true , 'checkOmsInventory':true,'isPdpPage':true, 'isRestrictedPostalCode': isRestrictedPostalCode,'targetedCartBehaviour' : targetedCart,'contractIdentifier':contractIdentifier},
                selected_products = [];
            $.each(formData, function(index, value){
                var dataName = formData[index].name;
                var dataValue = formData[index].value;
                if(dataName == 'relatedQty'){ dataName = 'quantity'; }
                if (!/_\d$/.test(dataName) && dataValue !== '' && dataValue !== '0') {
                    cleanData[dataName] = dataValue;
                }
            });
            var productIndex = 1;
            cleanData['catalogEntryId_'+productIndex] = cleanData['catEntryId'];
            if(cleanData['quantity'] == undefined){
                cleanData['quantity'] = $('#minQtyText').val();
                if( cleanData['quantity'] == undefined){
                	cleanData['quantity'] = 1;
                }
            }            
      	  	let isShipRestrictionStore = $('#shipRestrictionStore').val();
      	  cleanData['isShipRestrictionStore'] = isShipRestrictionStore;
            cleanData['quantity_'+productIndex] = cleanData['quantity'];
            $form.find('.variantContainer').each(function(i, p) {
                var dropdowns = $(p).find('option:selected').map(function(){ return $(this).val(); }).get();
                var swatches = $(p).find('.selected').map(function(){ return $(this).attr('value'); }).get();
                var selectedVariants = dropdowns.concat(swatches);
                var selected_product = phelper.findItem(products[i], selectedVariants);
                if (selected_product) {
                    quantity = phelper.item_type == 'bundle' 
                        ? parseInt($(p).find('[id^=qty-input] input').val())
                        : parseInt($('input[name=quantity]').val());
                    selected_product.quantity = quantity_text + quantity
                    var itemText = $('span.item-number-bundles').text().trim();
                    selected_product.isFsaChdItem = $('input[name=isFsaChdItem]', $(form)).val();
                    var bundle_item_number = (phelper.item_type == 'bundle') ? itemText+ '  '+(selected_product.partNumber || ""):"";
                    selected_product.item_number = (bundle_item_number == "") ? ($('span.item-number').text() || '#'+selected_product.partNumber || "") : bundle_item_number;
                    selected_product.final_price = phelper.item_type != 'bundle' ? final_price 
                            : $('.online-price[data-catentry='+selected_product.catentry+']').data('opvalue')
                                ? phelper.formatMoney(mathtable.calculateYourPrice(selected_product.catentry, true), true) 
                                : ''
                }
                if (selected_product && quantity > 0) {
                    selected_products = selected_products.concat(selected_product);
                    cleanData['catalogEntryId_'+productIndex] = selected_product.catentry;
                    cleanData['quantity_'+productIndex] = quantity;
                    productIndex++;
                }
            });
            if (phelper.item_type == 'single') {
                var selected_product = phelper.findItem(products[0], []);
                selected_product.quantity = quantity_text + $('input[name=quantity]').val();
                selected_product.item_number = $('span.item-number').text();
                selected_product.final_price = final_price;
                selected_product.isFsaChdItem = $('input[name=isFsaChdItem]', $(form)).val();
                selected_products = selected_products
                    .concat(selected_product);
            }

            if (typeof eddInstallationServicesJSON !== 'undefined') {
                cleanData['eddInstallationServicesJSON'] = JSON.stringify(eddInstallationServicesJSON);
            }

            var eddPrimaryClause = $('#eddPrimaryClause').val();
            if (typeof eddPrimaryClause !== 'undefined') {
            	cleanData['eddPrimaryClause'] = eddPrimaryClause;
            }
            
            $.ajax({
                url: "/AjaxManageShoppingCartCmd",
                type: 'POST',
                data: cleanData,
                dataType: 'json'
            }).done(function(data, textStatus, xhr){
            	
                data.selected_products = selected_products;
                data.form_id = form;
                $('#isPickUpItem').val(data.pickUp);
                $('#isSTWtem').val(data.isSTWPickUp);
                $('#isMDOItem').val(data.mdoPickUp);
                if (done) done(data, textStatus, xhr);
            	if(COSTCO.util.isNdEnabled()){
            		var surcharge = data.surchargeAmount;
                	var thresholdAmount = data.thresholdAmount;
                	var shipmethodId = data.shipmethodId;   
                	let toolTipDeliverySurcharge = data.toolTipDeliverySurcharge;
            		$('#freeDeliveryOrderAmount').val(parseFloat(thresholdAmount));
            		$('#deliverySurcharge').val(parseFloat(surcharge));
            		$('#toolTipDeliverySurcharge').val(parseFloat(toolTipDeliverySurcharge));
            		COSTCO.Header.displayTooltip(shipmethodId);
            	}
            	if (data.multipleRestricted) {
            		$form.find('.product-notification').html('<span>' + data.multipleRestricted + '<span>').show();
            	}
        	    $('input[name="associatedParentIds"]').val(data.associatedParentIds);
                COSTCO.Header.refreshGroceryBanner();
            }).fail(function(xhr, textStatus, errorThrown){
                if (fail) fail(xhr, textStatus, errorThrown)
            }).always(function(data, textStatus, errorThrown) {
                if (always) always(data, textStatus, errorThrown);
            });
        },

        has_error : function(data) {
        	let productErrorDiv;
        	let bundleProduct = $('#bundle-items-container').length !== 0 ? true : false;
        	if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
        		if (bundleProduct) {
        			productErrorDiv = $('#bundle-items-container').find('.product-error');
        		} else {
        			productErrorDiv = $(data.form_id + ' .product-error').length ? $(data.form_id + ' .product-error') : $('#pdp-sticky-container').find('.product-error');
        		}
        	}
            var relatedProductErrorDiv = $(data.form_id + ' .related-product-error');
            var errorCount = 0;
            if (data.errorCode) {
                errorCount++;
                if (data.errorCode == 2510) { // session timeout
                    document.location.href = 'Logoff?URL=ReLogonFormView';
                    return;
                }else{
                  if(data.errorCode && data.errorMessage){
                    productErrorDiv.append("<span class='sr-only'>" + messages.ERROR+ "</label>" + "<p class=\"span\">" + data.errorCode + data.errorMessage + "</p>");
                    COSTCO.util.logToClickTale(data, location.href, 151);
                    if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
                		$('#minQtyText ').addClass('error');
	                }
                  } else {
                    productErrorDiv.append("<span class='sr-only'>" + messages.ERROR + "</label>" + "<p class=\"span\" System Error adding to cart, please retry at a later time </p>");
                    COSTCO.util.logToClickTale(data, location.href, 152);
                  }
                }
            } else {
                if (data.orderErrMsgObj){
                    var errors = data.orderErrMsgObj;
                    var errorLoc = data.orderErrMsgLocObj;
                    for (var errorKey in errors) {                    	
                        if (errors.hasOwnProperty(errorKey)) {
                            errorCount++;
                            var isErrorPopup = false;
                            if(errorLoc.hasOwnProperty(errorKey)) {
                            	if(errorLoc[errorKey] === 'popup')
                            		isErrorPopup = true;
                            }
                            var errorMsg = errors[errorKey].replace('~', ',').replaceAll("''", "'");
                            if(isErrorPopup) {
                            	let msgContent = errorMsg;
            					if(COSTCO.util.isCAStore() && COSTCO.Header.checkIsRestricted()){
            						msgContent = messages.GROCERY_ITEM_UNAVAILABLE_TEXT;
            					}
                            	var modalOptions = {
                        	        title: messages.GROCERY_ITEM_UNAVAILABLE_TITLE,
                        	        body: '<p>' +msgContent +'</p>',
                        	        primary: messages.GROCERY_ITEM_UNAVAILABLE_PRIMARY,
                            		primary_event: function() {COSTCO.dialog.close()}
                        	      }
                            	COSTCO.dialog.showAndHideModal(modalOptions);                     
                            }
                            else
                            	if (errorKey === messages.SHIP_RESTRICTION_ERROR_KEY || errorKey === messages.SHIP_RESTRICTION_ERROR_KEY_CA || errorKey === messages.ERR_OMS_INVENTORY_API_FAILURE_ERROR){
                            		productErrorDiv.append( '<p class="alert-notification">' + errorMsg + '</p>');
                            		$('.product-error').removeClass('error');
                            		$('#prod-page-restriction').removeClass('hide');
                            	}
                            	else {
                            		if (errorKey === messages.RELATED_ITEM_ADD_ERROR_KEY){
                                		relatedProductErrorDiv.append('<p class="error">' + errorMsg + "</p>");
                                	}else{
                                		if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_PDP_FEATURE_ENABLE) {
                                			errorMsg = errorMsg.replace(/&lt;/g, '<')
                                			errorMsg = errorMsg.replace(/&gt;/g, '>')
                                			productErrorDiv.append( '<span><p class="sr-only">Error</p>' + errorMsg + '</span>');
                                			productErrorDiv.removeClass('hide');
                                			productErrorDiv.focus();
                                			if (Object.keys(oosFreeGiftAnalyticsMessages).includes(errorKey)) {
                                				window.digitalDataEvents = window.digitalDataEvents || [];
                                				digitalDataEvents.push({ uimsg: 'ProductDetail | Buy One Get One Free | Error | ' + oosFreeGiftAnalyticsMessages[errorKey] });
                                			}
                                		} else {
                                    		productErrorDiv.append("<span class='sr-only'>" + messages.ERROR + "</span>" + '<p class="error">' + errorMsg + '</p>');
                                		}
                            	}
                        }
                    }
                }
            }
            }
        return errorCount;
        },

        product_form_done : function(data, textStatus, xhr) {
            if (COSTCO.AddToCart.has_error(data) == 0) {
            	let paramData = data;
                if (data.redirecturl != null) {
                    urlWithoutQueryString = data.redirecturl.split('?')[0];
                    var appType = $('#applicationType').val();
                    if (urlWithoutQueryString.indexOf('CatalogSearch') != -1 
                    	|| urlWithoutQueryString.indexOf('CategoryDisplay') != -1
                        || (urlWithoutQueryString.indexOf('.html') != -1 
                            && urlWithoutQueryString.indexOf('.product.') == -1)
                    	|| (appType !== undefined && appType === 'BC' && 
                    			(urlWithoutQueryString.indexOf('QuickMembershipApplicationView') !== -1)
                    			|| urlWithoutQueryString.indexOf('MembershipApplicationView') !== -1)) {
                        var url = data.redirecturl;
                        delete data.redirecturl; 
                        delete data.selected_products;
                        var params = $.param(data);
                        var decodedUrl = $("<div/>").html(url).text();
                        var finalUrl;
                        if (decodedUrl.indexOf('?') != -1) {
                            if (decodedUrl.substr(decodedUrl.length - 1) == '&') {
                                finalUrl = decodedUrl + params;
                            } else {
                                finalUrl = decodedUrl + '&' + params;
                            }
                        } else {
                            finalUrl = decodedUrl + '?' + params;
                        }
                        document.location.href = finalUrl; 
                        return;
                    }
                }
                // Invoke add to cart modal
                phelper.added_modal(data.selected_products, data.orderItemId, data.itemMessage, data.originalQuantity);
                let quantity = '1';
                let langId = parseInt(COSTCO.util.getLangId());
                if (langId == -1 || langId == -24) {
                	quantity = data.selected_products[0].quantity.replace("Quantity ","");
                } else {
                	quantity = data.selected_products[0].quantity.replace("Quantité ","");
                }
                
                let price = data.selected_products[0].final_price.replace(" $","");
                let partNumber = parseInt(data.selected_products[0].partNumber);
                let orderItemId = data.orderItemId;
                let qtyBought = data.itemMessage;
                let itemInventory = data.selected_products[0].inventory === "IN_STOCK" ? "In stock" : "Out of stock";
                let orderId = data.orderId;
                var data = {
                    partNumber : partNumber,
                    price : price,
                    quantity : quantity,
                    orderItemId : orderItemId,
                    qtyBought: qtyBought
                };

                $('body').trigger("costco.cart.item.added", [data]);
                
                var windsorProductData = {
                    partNumber : partNumber,
                    price : price,
                    quantity: qtyBought,
                    inventory : itemInventory
                };
                try {
	                if ($("[name='adobeEventsFeatureFlagFooter']").val() == 'true') {
		                if (typeof contextVariables != 'undefined' && typeof  adobeProductData != 'undefined' && typeof  adobeProductData[0] != 'undefined') {
			                contextVariables.orderId = orderId;
			                adobeProductData[0].quantity = parseInt(quantity);
			                if(!($('#mymdGenericItemNumber').length > 0 && $('#mymdGenericItemNumber').val() == adobeProductData[0].SKU)){ 
			                	COSTCO.AdobeEvents.initEventIfLoggedIn('commerce.productListAdds', adobeProductData, adobeAnalyticsCommonData, contextVariables);
			                }
		                }
	                }    
                } catch(err) {
                	console.log('Problem with sending product data to Adobe');
                }
                
                $('body').trigger("windsor.product.cart.item.added", [windsorProductData]);
                $('#related-products-container').find('.sign-in').on( "click", function() {
                	sessionStorage.setItem('AddedToCartModalData',JSON.stringify(paramData));
            		window.digitalDataEvents = window.digitalDataEvents || [];
            		digitalDataEvents.push({
            			event: "interface interaction",
            			interfaceInteractionName: "sign in for price"
            		});
            	});
            }
            if($('#isPickUpItem').val()!='true'){
            	$('#add-to-cart input').removeAttr('disabled');
            	$('input[name=quantity]').removeAttr('disabled');
            }
            
        },

        product_form_fail : function() {
            $('#add-to-cart input').removeAttr('disabled')
        	$('input[name=quantity]').removeAttr('disabled');
        },

        product_form_always : function() {
            $('#add-to-cart input').removeAttr('disabled');
        	$('input[name=quantity]').removeAttr('disabled');
            COSTCO.Header.miniShopCartRefresh();
        },

        related_done : function(data, textStatus, xhr) {
            if (COSTCO.AddToCart.has_error(data) == 0) {
            	let addedToCartMessage = data.itemMessage == 1 ? messages.PDETAIL_ITEMS_ADDED_TO_CART : messages.PDETAIL_ITEMS_ADDED_TO_CART2;
            	
                $(data.form_id).find('.form_and_button').addClass('hide');
                $(data.form_id).find('.ctas').addClass('hide');
                $(data.form_id).find('.related-success')
                    .append('<p><i class="co-checkmark"></i> '+ addedToCartMessage +'</p>');
                
                //if called on replacement products modal on checkout pages, disable Cancel button to force user to go to View Cart
                if (typeof(checkoutPage) !== 'undefined') {
                	$('.related-products.replacements .add-buttons .btn-tertiary').prop('disabled', true);
                }
                
            } else {
                $(data.form_id).find('button.add-to-cart')
                    .removeAttr('disabled');
            }
        },

        related_fail : function(data, textStatus, errorThrown) {
            $(data.form_id).find('.product-error').append(errorThrown);
            $(data.form_id).find('button.add-to-cart')
                .removeAttr('disabled');
        },

        related_always : function(data, textStatus, errorThrown) {
            COSTCO.Header.miniShopCartRefresh();
        },
        
        getUrlParameter: function getUrlParameter(sParam) {
            let sPageURL = decodeURIComponent(window.location.search.substring(1));
            let sURLVariables = sPageURL.split('&');

            for (let i = 0; i < sURLVariables.length; i++) {
                let sParameterName = sURLVariables[i].split('=');

                if (sParameterName[0] === sParam) {
                    return sParameterName[1] === undefined ? true : sParameterName[1];
                }
            }
        },
        
        removeItemFromCart: function(orderId, orderItemsId, redirectUrl) {
        	let urlParam = {'actionType':'delete',
							'backURL':redirectUrl,
							'orderId':orderId,
							'orderItemId':orderItemsId
							};
			let removeItemfromCartUrl = 'ManageShoppingCartCmd?'+jQuery.param(urlParam);
			console.log(removeItemfromCartUrl);
			window.location.href = removeItemfromCartUrl;
        },
        
        removeMembersipItemFromCart: function() {
        	let orderId = COSTCO.AddToCart.getUrlParameter('orderId');
        	let orderItemId;
        	if(orderId == undefined) {
        		orderId = $('#membershipOrderId').val();
        		orderItemId = $('#membershipOrderItemId').val();
        	} else {
        		orderItemId = COSTCO.AddToCart.getUrlParameter('orderItemId');
        	}
        	
        	COSTCO.AddToCart.removeItemFromCart(orderId, orderItemId, "/");
        },
        acceptTermsAndConditions: function() {
        	
        	let command = '/UpdateTermsAndConditions';
        	let urlForRedirection = COSTCO.AddToCart.getUrlParameter('urlForRedirection');
        	let quickMembership = COSTCO.AddToCart.getUrlParameter('quickMembership');
        	let fromCheckout = COSTCO.AddToCart.getUrlParameter('fromCheckout');
        	let membershipOrderItemId = COSTCO.AddToCart.getUrlParameter('orderItemId');
        	
        	let urlParam = {'fromCheckout': fromCheckout,
		    				'quickMembership': quickMembership,
		    				'urlForRedirection': urlForRedirection,
		    				'membershipOrderItemId': membershipOrderItemId};
        	
        	var updateTermsAndConditions = command + '?' + jQuery.param(urlParam);
		    window.location.href = updateTermsAndConditions;
        }

    }
    if(typeof window.COSTCO == 'undefined'){
        window.COSTCO = new Object();
    }
    window.COSTCO.AddToCart = AddToCart;
    
    return AddToCart;
});


// WEBPACK FOOTER //
// ./js/product/addtocart.js